var interstellarDropdown = {};
interstellarDropdown.dropdown = function () {
  var $interstellarDropdownTitle = $(".interstellar-dropdown .interstellar-dropdown-title");
  var $interstellarDropdownFilterItem = $(".interstellar-dropdown .js-archiveFilter-item");
  var $interstellarDropdownMenu = $(".interstellar-dropdown .interstellar-dropdown-menu");
  $interstellarDropdownTitle.click(function () {
    var thisDropdown = $(this);
    if (thisDropdown.closest(".interstellar-dropdown").hasClass("show")) {
      thisDropdown.closest(".interstellar-dropdown").removeClass("show");
    } else {
      $interstellarDropdownMenu.removeClass("show");
      thisDropdown.closest(".interstellar-dropdown").addClass("show");
    }
  });
  $interstellarDropdownFilterItem.click(function () {
    var thisDropdown = $(this);
    if (thisDropdown.closest(".interstellar-dropdown").hasClass("show")) {
      thisDropdown.closest(".interstellar-dropdown").removeClass("show");
    }
  });
  window.onclick = function (event) {
    if (!event.target.matches(".js-dropdown-close-trigger")) {
      var dropdowns = document.getElementsByClassName("interstellar-dropdown");
      var i;
      for (i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i];
        if (openDropdown.classList.contains("show")) {
          openDropdown.classList.remove("show");
        }
      }
    }
  };
};
interstellarDropdown.dropdown();


// WEBPACK FOOTER //
// ./scripts/components/interstellar/dropdown.js